'use strict';

exports.__esModule = true;
exports.LinkDecorator = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Done = require('material-ui-icons/Done');

var _Done2 = _interopRequireDefault(_Done);

var _decorator = require('../../../components/decorator');

var _decorator2 = _interopRequireDefault(_decorator);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * В версии 0.11-alpha порядок методов отличается
 */
// function findLinkEntities(contentState, contentBlock, callback) {


function findLinkEntities(contentBlock, callback, contentState) {
  // return;
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
}

var LinkDecorator = exports.LinkDecorator = function (_Decorator) {
  _inherits(LinkDecorator, _Decorator);

  function LinkDecorator() {
    var _temp, _this, _ret;

    _classCallCheck(this, LinkDecorator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Decorator.call.apply(_Decorator, [this].concat(args))), _this), _this.onUrlChange = function (event) {
      var value = event.target.value;

      _this.updateData({
        url: value
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // static contextTypes = {
  //   ...Decorator.contextType,
  //   uri: PropTypes.object.isRequired,
  // }
  // componentWillReceiveProps(nextProps, nextState) {
  // }


  LinkDecorator.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        entityKey = _props.entityKey,
        contentState = _props.contentState,
        decoratedText = _props.decoratedText,
        isReadOnly = _props.isReadOnly,
        _onClick = _props.onClick;
    var _state = this.state,
        editing = _state.editing,
        showEditor = _state.showEditor;
    var readOnly = isReadOnly();

    var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
        url = _contentState$getEnti.url; // return <span>
    //   rgreg  rg gerg erg herg rger g <input />
    // </span>


    var helperText = "Укажите адрес ссылки";
    var Element = "a";
    var to = void 0;
    var uri = void 0;
    var target = void 0;
    var _global = global,
        location = _global.location;

    if (url) {
      uri = new _urijs2.default(url);
      /**
       * Если это текущий домен, то делаем ссылку локальной
       */

      if (location && uri.origin() === location.origin) {
        uri.origin("");
      }

      if (!uri.scheme()) {
        Element = _reactRouterDom.Link;
        to = uri.toString();

        if (!to.startsWith("/")) {
          to = '/' + to;
        }

        helperText = _react2.default.createElement(_Typography2.default, {
          color: 'secondary',
          component: 'span'
        }, "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443");
      } else {
        target = "_blank";
        helperText = _react2.default.createElement(_Typography2.default, {
          color: 'primary',
          component: 'span'
        }, "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A");
      }
    }

    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(Element, {
      href: url || "",
      to: to,
      target: target // onMouseEnter={this.toggleShowPopOver}
      // onMouseLeave={this.toggleShowPopOver}
      // onMouseDown={this.showEditor}
      ,
      onClick: function onClick(event) {
        if (!readOnly) {
          event.preventDefault();

          _this2.showEditor(event);

          return;
        }

        return _onClick && _onClick(event) || false;
      }
    }, children), !readOnly && (showEditor || !url) ? _react2.default.createElement('div', {
      style: {
        marginBottom: 20
      }
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      alignItems: 'center'
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }, _react2.default.createElement(_TextField2.default, {
      onMouseDown: this.showEditor,
      value: url || "",
      onChange: this.onUrlChange,
      onFocus: this.startEdit,
      onBlur: this.endEdit,
      fullWidth: true,
      label: "\u0410\u0434\u0440\u0435\u0441 \u0441\u0441\u044B\u043B\u043A\u0438",
      placeholder: 'https://...',
      helperText: helperText,
      error: !url
    })), _react2.default.createElement(_Grid2.default, {
      item: true
    }, _react2.default.createElement(_IconButton2.default, {
      onClick: this.hideEditor
    }, _react2.default.createElement(_Done2.default, {
      style: {
        color: "green"
      }
    }))))) : null);
  };

  return LinkDecorator;
}(_decorator2.default);

;

exports.default = function (config) {
  return _extends({
    strategy: findLinkEntities,
    component: LinkDecorator
  }, config);
};